<template>
	<div class="weather-events">
		<template>
			<div class="banner-wrapper" :class="alertHeadline">
				<div class="overlay-wrapper">
					<h2 v-if="alertHeadline">{{ content.weatherEvents[alertHeadline] }}</h2>
					<h6 class="store-name">{{ weather.storeName }}</h6>
				</div>
				<div class="weather-wrapper">
					<div class="current-weather">
						<div class="weather-day" v-for="(day, index) in weather.weatherInfo.daysWeatherInfo.slice(0, 3)"
							:key="index">
							<p class="day">{{ formatDay(index, day.day) }}</p>
							<div class="circle-wrapper">
								<img :src="getWeatherIcon(day.conditionEn)" :alt="getCondition(day)">
							</div>

							<div class="temp">
								<p class="high">
									<span class="temp-value">{{ formatTemp(day.maxTemp) }}</span>&deg;<span>C</span>
								</p>
								<p  v-if="globalMetricFlag" class="weather-metric">
									
									<span v-if="shouldShowMetric(day.conditionEn, 'rain') || day.totalPrecip > 0">{{day.totalPrecip }}in</span>
									<span v-if="shouldShowMetric(day.conditionEn, 'snow') || day.totalSnow > 0">{{day.totalSnow }}cm</span>
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="product-grid" :class="alertHeadline">
				<div v-for="(product, index) in products" :key="index" class="product-card" tabindex="0"
					:class="{ 'flex-50': products.length === 4, 'flex-30': products.length <= 6 && products.length > 4 }">
					<div class="content">

						<div class="product-desc-wrapper">
							<div class="savings" v-if="product.saveInt !== 0">
								<p>{{ content.weatherPromos.save }}</p>
								 <p class="save-int">
									<span class="save-number">{{ product.save.replace('%', '') }}</span>
									<span class="save-percent">%</span>
								</p>
							</div>
							<p v-if="!isQuebec" class="product-price">${{ product.salePrice }}</p>
							<p v-if="!isQuebec && product.regularPrice !== product.salePrice" class="product-reg-price">
								${{product.regularPrice }}</p>
							<p class="product-desc">{{ productDesc(product) }}</p>

						</div>
						<div class="product-image">
							<img alt="" :src="product.productImage">
						</div>
						<div v-if="isVisible">
							<product-click-regions :key="product.sku + index" :block="block" :block-data="blockData"
								:is-visible="isVisible" :page="page" :product="product" v-on="$listeners"
								class="overrideStyles" @onRegionClick="handleDynamicPromoClick(product)" />
						</div>
					</div>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import blockElementMixin from "@/mixins/blockElementMixin";
import { PRODUCT_REGION_CLICK } from "@/components/block/BlockEvents";
import ProductClickRegions from "@/components/block/elements/ProductClickRegions.vue";
import Lytics from "../../classes/Lytics";


export default {
	name: "WeatherEvents",
	mixins: [blockElementMixin],
	components: { ProductClickRegions, },
	props: {
		weatherEventsData: Object,
	},
	data() {
		return {
			weather: {
				weatherInfo: []
			},
			products: [],
			finelineNMs: [],
			lastcategory: [],
		}
	},
	created() {
		this.weather = this.page.data
		this.products = this.weather.products
		this.finelineNMs = this.weather.weatherInfo.alerts[0].finelineNMs;
		this.filterProducts();

	},
	watch: {
		isVisible(newVal) {
			if (newVal) {
				this.products.forEach((product) => {
					Lytics.TriggerDynamicPromoImpression({
						id: product.sku,
						name: product.productEn,
						img: product.productImage,
						type: "weather"
					})
				});
			}
		}
	},
	computed: {
		...mapState(['pages']),
		...mapGetters(['content', 'language', 'storeId']),
		...mapGetters('screen', ['displayMode', 'flyerOrientation']),
		isQuebec() {
			if (!this.weather.storeName) return false;
			const parts = this.weather.storeName.split(',');
			if (parts.length < 2) return false;
			const provinceCode = parts[1].trim().toUpperCase();
			return provinceCode === 'QC';
		},
		globalMetricFlag() {
			return this.weather.weatherInfo.daysWeatherInfo.some(day => this.shouldShowMetric(day.conditionEn, 'snow') ||
		    this.shouldShowMetric(day.conditionEn, 'rain') )
		},

		alertHeadline() {
			let priority = this.weather.weatherInfo?.alerts[0].priority;
            const priorityMap  ={
				1: 'snowAlert',
				2: 'coldAlert',
				3: 'heatAlert',
				4: 'rainAlert'
			};
			return priorityMap[priority]
		},
		isVerticalOnDesktop() {
			return this.displayMode === 'desktop' && this.flyerOrientation === 'vertical';
		},
		firstDay() {
			return this.weather?.weatherInfo?.daysWeatherInfo?.length ? this.weather?.weatherInfo?.daysWeatherInfo[0] : null;
		},
	},
	methods: {
		...mapActions('events', ['triggerEvent']),
		getWeatherIcon(condition) {
			const iconMap = {
				sunny: '/icons/weather-events/weather-sunny.svg',
				cloudy: '/icons/weather-events/weather-cloud.svg',
				rain: '/icons/weather-events/weather-rain.svg',
				storm: '/icons/weather-events/weather-thunder.svg',
				hail: '/icons/weather-events/weather-hail.svg',
				fog: '/icons/weather-events/weather-fog.svg',
				mist: '/icons/weather-events/weather-fog.svg',
				overcast: '/icons/weather-events/weather-heat.svg',
				snow: '/icons/weather-events/weather-snow.svg',
				cold: '/icons/weather-events/weather-cold.svg',
				sleet: '/icons/weather-events/weather-extreme-cold.svg',
				ice: '/icons/weather-events/weather-extreme-cold.svg',
				freezing: '/icons/weather-events/weather-snow.svg',
				blizzard: '/icons/weather-events/weather-blizzard.svg',
			}

			for (const key in iconMap) {
				if (condition.toLowerCase().includes(key)) {
					return iconMap[key];
				}
			}
		},
		shouldShowMetric(conditionEn, type) {
			if (!conditionEn || !type) return false;
			return conditionEn.toLowerCase().includes(type);

		},
		formatTemp(temp) {
			return temp < 10 ? ` ${temp}` : `${temp}`
		},
		formatDay(index, day) {
			let dayLower = day.toLowerCase();
			let finalDay
			if (index === 0) { return (this.language === 'en') ? 'Today' : `Aujourd'hui` }
			if (this.language === 'fr') {
				if (dayLower === 'monday') finalDay = 'Lundi'
				if (dayLower === 'tuesday') finalDay = 'Mardi'
				if (dayLower === 'wednesday') finalDay = 'Mercr.'
				if (dayLower === 'thursday') finalDay = 'Jeudi'
				if (dayLower === 'friday') finalDay = 'Vendr.'
				if (dayLower === 'saturday') finalDay = 'Sam.'
				if (dayLower === 'sunday') finalDay = 'Dim.'

			} else {
				finalDay = dayLower === 'thursday' ? day?.slice(0, 4) : day?.slice(0, 3)
			}
			return finalDay
		},

		getCondition(day) {
			return (this.language === 'fr') ? day.conditionFr : day.conditionEn
		},
		filterProducts() {
			const limit = 9;
			this.products = this.products.sort((a, b) => b.saveInt - a.saveInt)
			this.products = [...this.products?.slice(0, limit)]
		},

		productDesc(product) {
			return (this.language === 'fr') ? product.productFr : product.productEn;
		},
		onClick(product) {
			this.triggerEvent({ 'event': PRODUCT_REGION_CLICK, data: product })
			this.$emit('onRegionClick', this, 'productRegion');
		},
    handleDynamicPromoClick(product) {
			Lytics.TriggerDynamicPromoClick({
				id: product.sku,
				name: product.productEn,
        img: product.productImage,
        link_name: "",
        type: "weather"
			})
		}
	},
}
</script>

<style lang="scss" scoped>
.weather-events {
	font-family: Lato, sans-serif;
	--red-color: #D81E05;
	--grey-color: #D3D3D3;
	display: grid;
	width: 100%;
	height: 100%;

	.banner-wrapper {
		display: flex;
		padding: 2% 0;

		.overlay-wrapper {
			display: flex;
			flex-direction: column;
			justify-content: center;
			flex: 3;
			color: #262626;
			max-width: unset;
			margin-left: 3%;

			h2 {
				font-family: CTEastman-Bold, sans-serif;
				font-size: 1.25rem;
			}

			h6.store-name {
				text-transform: capitalize;
				font-size: 0.7rem;
				margin-top: 8px;
			}
		}

		.weather-wrapper {
			flex: 1;
			padding-right: 15px;
			display: flex;
			justify-content: center;
			color: #262626;

			.current-weather {
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 0.6em;
				gap: 20px;

				.weather-day {
					display: flex;
					flex-direction: column;
					align-items: center;

					.temp {
						.weather-metric {
							margin-top: 3px;
							min-height: 12px;
							span {
								color: #737373;
								
							}
						}
					}

					.circle-wrapper {
						width: 32px;
						height: 32px;
						background-color: #fff;
						border-radius: 50%;
						margin: 5px 0;
					}
				}
			}
		}
	}

	.banner-wrapper.snowAlert {
		background: #E5EFF9;
	}

	.banner-wrapper.coldAlert {
		background: #E5EFF9;
	}

	.banner-wrapper.heatAlert {
		background: #FFEBD7;
	}

	.banner-wrapper.rainAlert {
		background: #BFD9F1;
	}

	img {
		width: 100%;
		height: auto;
	}

	.product-grid {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		grid-template-rows: repeat(3, 138px);
		padding: 2px 8px;

		.product-card.flex-30 {
			flex: 30%;
		}

		.product-card.flex-50 {
			flex: 45%;
		}

		.product-card {
			padding: 7px;
			margin: 3px 3px;
			background-color: #fff;
			position: relative;
			cursor: pointer;

			.content {
				display: flex;

				.product-desc-wrapper {
					flex: 1.05;
				}

				.product-image {
					max-height: 78px;
					display: flex;
					flex: 1;

					img {
						padding: 6px 0;
						object-fit: contain;
					}
				}

				.product-name {
					margin: 5px 0;
					font-size: 8px;
					text-transform: uppercase;
				}

				.savings {
					color: var(--red-color);
					font-family: 'Lato SemiBold', sans-serif;
					text-transform: uppercase;
					font-size: 10px;
					margin-bottom: 4px;

					.save-int {
                        font-family: CTEastmanCompressed-Bold, sans-serif;
						margin-top: 3px;

						.save-number {
							font-size: 32px;
						}

						.save-percent {
							font-size: 14px;
							position: relative;
							top: -12px;
						}
                    }
				}

				.product-price {
					font-family: 'Lato SemiBold', sans-serif;
					color: var(--red-color);
					font-size: 12px;
				}

				.product-reg-price {
					font-family: Lato, sans-serif;
					font-size: 10px;
					text-decoration: line-through;
					color: #737373;
					margin-top: 1px;
				}

				.product-desc {
					line-height: 13px;
					font-size: 9px;
					margin-top: 5px;
					color: #262626;
					display: -webkit-box;
					-webkit-line-clamp: 3;
					-webkit-box-orient: vertical;
					overflow: hidden;
					text-overflow: ellipsis;
				}
			}

			.overrideStyles.product-click-regions {
			

				div.product-click-region {
					position: absolute;
					top: 0 !important;
					left: 0 !important;
					width: 100% !important;
					height: 100% !important;
					z-index: 99 !important;
				}
			}
		}
	}

	.product-grid.snowAlert {
		background: #F5FAFF
	}

	.product-grid.coldAlert {
		background: #F5FAFF
	}

	.product-grid.heatAlert {
		background: #FDF4EE
	}

	.product-grid.rainAlert {
		background: #E5EFF9
	}
}
</style>

<style lang="scss">
[mode='mobile'] [page-id='weatherEvents'].section-container,
[mode='mobile'] [page-id='weatherEventsPageTwo'].section-container {
	position: relative;

	&>.flyer-block.WeatherEvents {
		grid-area: span 8 / span 2 / auto / auto !important;

		.banner-wrapper {
			padding: 4% 0;
			flex: 1;

			.overlay-wrapper {
				flex: 1;
				h2 {
					font-size: 1.4em;
				}
			}

			.weather-wrapper {
				padding-right: 0;
				.current-weather {
					font-size: 11px;

					.circle-wrapper {
						width: 38px;
						height: 38px;
					}
				}
			}
		}

		.product-grid {
			grid-template-columns: repeat(2, 1fr);
			 grid-template-rows: repeat(3, 142px);

			.product-card {
				flex: 35% !important;
				height: 130px;

				.content {
					.product-name {
						font-size: 0.8em;
					}
					.product-desc {
						line-height: 13px;
						font-size: 0.8em;
					}
				}
			}
		}
	}
}

[mode='tablet'] [page-id='weatherEvents'].section-container,
[mode='tablet'] [page-id='weatherEventsPageTwo'].section-container {
	position: relative;

	&>.flyer-block.WeatherEvents {
		grid-area: span 4 / span 3 / auto / auto !important;

		.banner-wrapper {
			padding: 1.4% 0;

			.overlay-wrapper {
				h2 {
					font-size: 1.9em;
				}
			}

			.weather-wrapper {
				.current-weather {
					font-size: 0.9em;

					.circle-wrapper {
						width: 38px;
						height: 38px;
					}
				}
			}
		}

		.product-grid {
			grid-template-rows: repeat(3, 146px);
			padding: 8px 4px;

			.product-card {
				.content {

					.product-name {
						font-size: 0.8em;
					}

					.savings {
						font-size: 1.1em;
					}

					.product-desc {
						font-size: 0.8em;
						line-height: 13px;
					}

					.product-image {
						max-height: 115px;
					}
				}
			}
		}
	}
}

[mode='desktop'] [flyer-orientation='vertical'] [page-id='weatherEvents'].section-container,
[mode='desktop'] [flyer-orientation='vertical'] [page-id='weatherEventsPageTwo'].section-container {
	position: relative;

	&>.flyer-block.WeatherEvents {
		grid-area: span 3 / span 3 / auto / auto !important;

		.banner-wrapper {
			padding: 2% 0;

			.overlay-wrapper {
				h2 {
					font-size: 1.9em;
				}
			}

			.weather-wrapper {
				.current-weather {
					font-size: 0.9em;

					.circle-wrapper {
						width: 38px;
						height: 38px;
					}
				}
			}
		}

		.product-grid {
			grid-template-rows: repeat(3, 146px);
			.product-card {
				.content {
					.product-image {
						max-height: 105px;
					}

					.product-name {
						font-size: 10px;
					}

					.savings {
						font-size: 14px;
					}

					.product-desc {
						font-size: 10px;
						line-height: 12px;
					}
				}
			}
		}
	}
}
</style>
